import React, { createContext, useState, useEffect,useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import cityService from '../services/CityService';
import useMarkerSelection from '../../hooks/useMarkerSelection';
import SavedMapService from '../services/SavedMapService';
import { getWithExpiry } from './../utils/StoreDataWithTimeLimit'

export const CityContext = createContext();

export const CityProviderForUser = ({ children }) => {
    console.log("here")
    const [changedCheckBoxId, setChangedCheckBoxId] = useState(null);
    const { cityName } = useParams();
    console.log("here",cityName)
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const mapId = queryParams.get('mapId');
    const [loading, setLoading] = useState(true);
    const [city, setCity] = useState(null);
    const [error, setError] = useState('');
    const [selectedMarker, setSelectedMarker] = useMarkerSelection(city?._id, setError);
    const tempCheckData=useRef()


    useEffect(() => {
        const controller = new AbortController();
        setLoading(true); setError(''); setCity(null);
        const fetchCity = async () => {
            try {
                let cityData;

                if (mapId && mapId != "temp") {
                    const [savedMapData, cityDataResponse] = await Promise.all([
                        SavedMapService.getSavedMapById(mapId),
                        cityService.getCityByName(cityName, controller.signal)
                    ]);

                    cityData = cityDataResponse;
                    cityData.mapId = mapId
                    cityData.mapData = savedMapData; // Assuming `checkData` is where you want to store savedMapData
                }

                else {
                    cityData = await cityService.getCityByName(cityName, controller.signal);
                }

                if (mapId && mapId == "temp") {
                    let checkData=getWithExpiry("checkData")
                    
                    if(checkData)
                        tempCheckData.current=checkData

                    
                    if (tempCheckData){
                        
                        cityData.mapData={}
                        cityData.mapData.checkData=tempCheckData.current
                    }
             }

                if (!controller.signal.aborted) setCity(cityData);
            } catch (err) {
                if (!controller.signal.aborted) setError(err.message);
            } finally {
                if (!controller.signal.aborted) setLoading(false);
            }
        };

        fetchCity();
        return () => controller.abort();
    }, [cityName, mapId]);

    return (
        <CityContext.Provider value={{ changedCheckBoxId, setChangedCheckBoxId, city, loading, error, setSelectedMarker, selectedMarker }}>
            {error && <div role="alert">{error}</div>}
            {children}
        </CityContext.Provider>
    );
};
